import React from 'react';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import {organizationRequest, organizationEditRequest} from '../../actions/action_organization';
import Alert from '../Alert';
import Title from '../Title';
import messages from '../../../res/translations/messages';
import Loader from '../Loader';
import BrandingForm from './BrandingForm';

class Branding extends React.Component {
    constructor(props) {
        super(props);
        this.handleReset = this.handleReset.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        this.props.organizationRequest();
    }

    handleReset() {
        this.handleSubmit({});
    }

    handleSubmit(values) {
        const organization = Object.assign({}, this.props.item, {branding: values});
        this.props.organizationEditRequest(organization);
    }

    render() {
        const {error, item, loading} = this.props;
        return (
            <div className="container">
                <Title><FormattedMessage {...messages.admin.branding.title} /></Title>
                {error && <Alert error={error} />}
                {!item && loading && <Loader />}
                {item && <BrandingForm item={item} onReset={this.handleReset} onSubmit={this.handleSubmit} loading={loading} />}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    error: state.organization.error,
    item: state.organization.current,
    loading: state.organization.loading,
});

export default connect(mapStateToProps, {organizationRequest, organizationEditRequest})(Branding);
